/* unplugin-vue-components disabled */import "core-js/modules/es.number.constructor.js";
/* this file is transformed by vux-loader */
/* eslint-disable */
import "core-js/modules/es.number.constructor.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    isCard: {
      type: Boolean,
      default: false
    },
    swipe: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      isShow: false,
      deltaX: '0px'
    };
  },
  computed: {
    miniStyle: function miniStyle() {
      var miniStyle = {};
      miniStyle.height = '';
      miniStyle.padding = '1rem 1rem .5rem';
      miniStyle.imgHeightWidth = '4.8rem';
      miniStyle.imgBorderRadius = '.24rem';
      miniStyle.translate3d = "translate3d(".concat(this.deltaX, ", 0px, 0px)");
      return miniStyle;
    }
  },
  methods: {
    swipeleft: function swipeleft(e) {
      if (!this.swipe) {
        return;
      }
      var fontSize = window.getComputedStyle(window.document.documentElement)['font-size'];
      fontSize = Number(fontSize.substr(0, fontSize.length - 2)); // rem to px
      var btnWidth = 1 * 5 * fontSize;
      this.deltaX = Math.abs(e.deltaX) > btnWidth ? btnWidth * -1 : e.deltaX;
      this.deltaX += 'px';
    },
    swiperight: function swiperight(e) {
      if (!this.swipe) {
        return;
      }
      this.deltaX = e.deltaX > 0 ? 0 : e.deltaX + 'px';
    },
    panstart: function panstart(e) {
      if (e.direction === 2) {
        e.srcEvent.stopPropagation();
        this.swipeleft(e);
      }
      if (e.direction === 4) {
        this.swiperight(e);
      }
    }
  }
};